export default {
  new_page_id: '新しいFacebookページID',
  check_page_id_button: 'チェック',
  update_user_page_button: '編集',
  page_status_pending:
    'ページ名: {page}。ページのリクエストは承認待ちです。リクエストが承認される後もう一度お試しください。',
  page_status_accepted:
    'ページ名: {page}。ユーザーのページはこのページに変更できます。「編集」ボタンを押して変更を進んでください。'
};
